// extracted by mini-css-extract-plugin
export default {"deleteOverlay":"F6-z","cancel":"G6-z","disabled":"H6-z","delete":"I6-z"};